export const API_HOST = "https://api.farmflix.tv";
export const STRIPE_CLIENT_SECRET = "pk_live_FDrJKadvONb4IgyAtGZxXEZa";
export const GOOGLE_CAPTCHA_SITE_KEY =
  "6LcNw8UhAAAAAGZSzO7jpJ50agOKz0cW2pF1F-Bo";
export const MUX_DATA_ENV_KEY = "lpm1fijjg3af193uq0g7spk06";
export const ENABLE_ROLLBAR = true;
export const ENABLE_PRERENDER = true;
